// Vendora88 support contact — shown on the landing page footer and in the vendor's profile
// menu. Kept in one place so a number change is a one-line edit.

export const SUPPORT_PHONE = '9849344316';
export const SUPPORT_PHONE_DISPLAY = '98493 44316';

export const supportCallHref = `tel:+91${SUPPORT_PHONE}`;

// Opens a WhatsApp chat with support, with a message already typed so the person only has to
// press send.
export const supportWhatsAppHref = (message = 'Hi, I would like to know more about Vendora88.') =>
    `https://wa.me/91${SUPPORT_PHONE}?text=${encodeURIComponent(message)}`;
